import React, { forwardRef } from "react";
import { cn } from "./cn";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  wrapperClassName?: string;
};

const Input = forwardRef<HTMLInputElement, Props>(
  ({ leadingIcon, trailingIcon, className, wrapperClassName, ...rest }, ref) => (
    <div className={cn("relative", wrapperClassName)}>
      {leadingIcon ? (
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
          {leadingIcon}
        </span>
      ) : null}
      <input
        ref={ref}
        className={cn(
          "h-10 w-full rounded-xl border border-gray-200 bg-white text-sm text-gray-900 placeholder:text-gray-400 shadow-sm transition-colors",
          "focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/20",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          leadingIcon ? "pl-9" : "pl-3",
          trailingIcon ? "pr-9" : "pr-3",
          className,
        )}
        {...rest}
      />
      {trailingIcon ? (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
          {trailingIcon}
        </span>
      ) : null}
    </div>
  ),
);

Input.displayName = "Input";

export default Input;
